export default __webpack_public_path__ + "media/images/images/jvqmap/marker/black-552c78f4dbb97926f85e9207c4f71136.png";